import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {

  constructor(
    private http: HttpClient
  ) { }

  fsbBrowser(parameters?: any) {
    let link = `${environment.protheus}/browser?${parameters}`;
    return this.http.get(link);
  }

  anexaArquivo(arquivo: any) {
    return this.http.post(`${environment.protheus}/upload`, arquivo);
  }
}
